import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE } from 'react-admin';

import { ResourceDefinition, ResourceSections } from 'src/types';

export const OrganizationSettingsResource: ResourceDefinition = {
  name: 'organization_settings',
  section: ResourceSections.PORTAL,

  extension: {
    operations: {
      [GET_LIST]: {
        operationName: 'portal_organization_settings',
      },
      [GET_ONE]: {
        operationName: 'portal_organization_settings',
      },
      [GET_MANY]: {
        operationName: 'portal_organization_settings',
      },
      [GET_MANY_REFERENCE]: {
        operationName: 'portal_organization_settings',
      },
    },
  },
};
